import { auth } from "../../Firebase";
import {
  confirmPasswordReset,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signOut,
  updatePassword,
  verifyPasswordResetCode,
  FacebookAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { toast } from "react-toastify";
import { CONNEXION_NAVIGATION, PASSWORD_OUBLIER_NAVIGATION } from "../../Routes/NAVIGATION_PATH";
import { authRoutes } from "../../Routes/routes";
import { Navigate } from "react-router-dom";
export const registerUser = (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

export const loginUser = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const connectWithFacebook = () => {
  const provider = new FacebookAuthProvider();
  return signInWithPopup(auth, provider)
};

export const signOutUser = (navigate) => {
  signOut(auth)
    .then(() => {
      sessionStorage.clear();
      toast.success("La déconnexion à bien reussie!");
      navigate("/");
    })
    .catch((error) => {
      toast.error("Erreur, réessayer!");
      const errorCode = error.code;
      console.log(errorCode);
    });
};

export const UpdatePassword = async (newPassword, navigate) => {
  updatePassword(auth.currentUser, newPassword)
    .then(() => {
      // Update successful.
      toast.success("Mot de passe modifié avec succès !");
      navigate("");
    })
    .catch((error) => {
      // An error ocurred
      toast.warning("Mot de passe faible, utlisez minimum 6 caractères !");
      console.error("Error updating password: ", error);
    });
};


export const forgetPassword = (email, navigate) => {
  sendPasswordResetEmail(auth, email)
    .then(() => {
      toast.success("Un mail vous a été envoyer, consultez votre boite mail !");
      navigate("/");
    })
    .catch((error) => {
      toast.error("Email Introuvable !");
    });
};

export const resetPassword = (newPassword, navigate) => {
  // Récupération des paramètres de l'URL
  const params = new URLSearchParams(window.location.search);
  const mode = params.get("mode");
  const oobCode = params.get("oobCode");
  const apiKey = params.get("apiKey");
  const lang = params.get("lang");
  verifyPasswordResetCode(auth, oobCode)
    .then((email) => {
      const accountEmail = email;
      confirmPasswordReset(auth, oobCode, newPassword)
        .then(() => {
			//Quand la modification reussie
			toast.success("Mot de réinitialiser avec succès !")
			navigate("/")
		})
        .catch((error) => {
			const message = error.code
			if(message === "auth/weak-password"){
				toast.warning("Mot de passe faible, utlisez minimum 6 caractères !")
			}else if (message === "auth/user-disabled"){
				toast.error("Utilisateur desactivé par l'admin")
				navigate("/")
			}else if (message === "auth/user-not-found"){
				toast.error("Aucun utilisateur associer à ce mail !")
			}
		});
    }).catch((error) => {
		const message = error.code
		if(message === "auth/invalid-action-code"){
			toast.warning("Renvoyer un mail, car le mail precedent n'est plus valide !")
			navigate("/")
		}else if(message === "auth/expired-action-code"){
			toast.warning("Temps de validité expirer, reessayer de nouveau !")
			navigate('/')
		}
	});
};



